// p9: если короткий элемент обрезан многоточием, показываем полный текст в title (hover; на тач - long-press).
const SEL = 'button, a, label, [role="tab"], [class*="chip" i], [class*="badge" i], [class*="pill" i]';
function fill(e: Event) {
  const t = e.target as Element | null;
  const el = t && 'closest' in t ? (t.closest(SEL) as HTMLElement | null) : null;
  if (!el || el.hasAttribute('title')) return;
  if (el.scrollWidth > el.clientWidth + 1) {
    const text = (el.innerText || '').replace(/\s+/g, ' ').trim();
    if (text) el.setAttribute('title', text);
  }
}
export function installTruncateTitle() {
  if (typeof document === 'undefined' || (window as any).__p9tt) return;
  (window as any).__p9tt = true;
  document.addEventListener('pointerover', fill, { passive: true });
  document.addEventListener('focusin', fill);
  document.addEventListener('touchstart', fill, { passive: true });
}
